export default __webpack_public_path__ + "static/media/Exteriors 042.9a9908da.jpg";